import "./Css/ResultTabel.css";
import { useNavigate, useLocation } from "react-router-dom";

import React, { useState, useEffect } from "react";
import API_BASE from "../config/api";


const ResultTabel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)
  const [paperDetails, setPaperDetails] = useState(null);
  const [students, setStudents] = useState([]);

  const filteredData = students.filter((stu) =>
    stu.studentName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    stu.studentUniqueId.toLowerCase().includes(searchQuery)
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );


  useEffect(() => {
    if (!location.state?.examId) return;

    const fetchData = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/api/Papers/${location.state.examId}/details`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
          }
        });

        const data = await res.json();

        setPaperDetails(data);
        setStudents(data.students || []);
      } catch (err) {
        console.error("Failed to load paper details", err);
      }
    };

    fetchData();
  }, [location.state]);



  return (
    <div className="exam-page-wrapper">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          परीक्षा व्यवस्थापन   &gt;&gt; <span>निकाल जाहीर करा</span>
        </h3>

        <div className="edit-btnn">
          <button
            className="btnprimaryyy"
            onClick={() => setShowPopup(true)}
          >
            निकाल जाहीर करा
          </button>
        </div>

      </div>

      <div className="filters">
        <div className="search-wrapper-exam">
          <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
            <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
          <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
        </div>
      </div>

      {/* Info Cards */}
      <div className="exam-info-cards">
        <div className="info-card">परीक्षेचे नाव<br /><b>{paperDetails?.paperName}</b></div>
        <div className="info-card">इयत्ता<br /><b>{paperDetails?.standardName}</b></div>
        <div className="info-card">विषय<br /><b>{paperDetails?.subjectName}</b></div>
        <div className="info-card">परीक्षेची तारीख<br />
          <b>
            {paperDetails?.publishedDate
              ? new Date(paperDetails.publishedDate).toLocaleDateString("mr-IN", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })
              : "-"}
          </b>
        </div>
        <div className="info-card">कालावधी<br /><b>{paperDetails?.duration} मिनिटे</b></div>
        <div className="info-card">एकूण गुण<br /><b>{paperDetails?.marks}</b></div>
      </div>

      {/* Table */}
      <div className="exam-table-wrapper">
        <table className="exam-result-table">
          <thead>
            <tr>
              <th>क्र.</th>
              <th>विद्यार्थी ID</th>
              <th>विद्यार्थी नाव</th>
              <th>इयत्ता</th>
              {/* <th>रोल नं</th>  */}
              <th>ईमेल</th>
              {/* <th>नियुक्त शिक्षक</th> */}
              {/* <th>स्थिती</th> */}
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((stu, index) => (

              <tr key={index}>
                <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                <td>{stu.studentUniqueId}</td>
                <td>{stu.studentName}</td>
                <td>{stu.standardName}</td>
                {/* <td>{stu.roll}</td> */}
                <td>{stu.email}</td>
                {/* <td>{stu.teacher}</td> */}
                {/* <td>

                  {stu.status}
                </td> */}
                <td>
                  <span
                    className="view-result-link"
                    onClick={() =>
                      navigate(`/dashboard/studentresult/${stu.attemptId}`, {
                        state: { attemptId: stu.attemptId }
                      })
                    }
                  >
                    View Result
                  </span>
                </td>

              </tr>
            ))}
          </tbody>

        </table>
      </div>
      {showPopup && (
        <div className="result-popup-overlay">
          <div className="result-popup-box">
            <div className="result-popup-icon">
              ✓
            </div>

            <h3>निकाल जाहीर करायचा आहे का?</h3>
            <p>
              एकदा निकाल जाहीर झाल्यावर तो सर्व विद्यार्थ्यांना दिसेल.
            </p>

            <div className="result-popup-actions">
              <button
                className="result-cancel-btn"
                onClick={() => setShowPopup(false)}
              >
                रद्द करा
              </button>

              <button
                className="result-confirm-btn"
                onClick={() => {
                  setShowConfirmPopup(false);
                  setShowSuccessPopup(true); // 👉 open success popup
                }}
              >
                निकाल जाहीर करा
              </button>
            </div>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div className="result-popup-overlay">
          <div className="result-popup-box result-success-box">
            <span
              className="close-icon"
              onClick={() => {
                setShowSuccessPopup(false);

                navigate("/dashboard/exammanagment", {
                  state: {
                    publishedResultExamId: location.state?.examId
                  }
                });
              }}
            >
              ✕
            </span>


            <div className="result-popup-icon success-icon">✓</div>

            <h3>निकाल यशस्वीरित्या जाहीर झाला!</h3>
            <p>विद्यार्थ्यांना निकाल पाहता येईल.</p>
          </div>
        </div>
      )}

      <div className='que-pagination-container'>
        <div className="que-pagination-controlss">
          <button
            className="que-pagination-btn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>

          {[...Array(totalPages).keys()]
            .map((_, i) => i + 1)
            .slice(
              Math.max(currentPage - 2, 0),
              Math.min(currentPage + 1, totalPages)
            )
            .map((page) => (
              <button
                key={page}
                className={`que-pagination-btn ${currentPage === page ? 'active' : ''
                  }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}

          <button
            className="que-pagination-btn"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
          {/* Rows per page and range info */}
          <div className="que-pagination-controls">
            <span className="que-rows-label">Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="que-rows-dropdown"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultTabel;
